import React from "react";
import {Members} from "./members/Members";
import {QueryClient, QueryClientProvider} from 'react-query';
import {getCurrentUser, isMinimalApp} from "./CommonFunctions";
import {HeaderTabs} from "./common/HeaderTabs";

const queryClient = new QueryClient();

export const MembersMain = () => {

    const headerLinks = [
        {label: 'Profil', path: 'profile'},
        {label: 'Organisation', path: 'organization', visible: !isMinimalApp()},
        {label: 'Membres', path: 'members', visible: getCurrentUser().admin},
        {label: 'Connectivité', path: 'connectivity'},
        {label: 'Aide', path: 'help'}
    ];

    return (
        <>
            <HeaderTabs links={headerLinks} defaultPath='members'/>

            <div id="main-grid__item--main-content" className="main-grid__item">
                <div id="main-content">
                    {getCurrentUser().admin &&
                        <QueryClientProvider client={queryClient}>
                            <Members/>
                        </QueryClientProvider>
                    }
                </div>
            </div>
        </>
    )
}


